import { login, logout, getInfo } from '@/api/login'
import { getRoleList } from '@/api/role'
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  state: {
    token: getToken(),
    userInfo: null,
    roles: [],
    permissions: [],
    // userTypes: [],
    banks: [],
    menus: [],
    regionsInfo: [],
  },
  mutations: {
    SET_STATE: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
    SET_PERMISSIONS: (state, permissions) => {
      const list = {}
      for (let i = 0; i < permissions.length; i++) {
        list[permissions[i]] = true
      }
      state.permissions = list
    }
  },
  actions: {
    Login({ commit }, userInfo) {
      const username = userInfo.username ? userInfo.username.trim() : null
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.captcha).then(res => {
          if (res.data.token) {
            // 移除 localStorage 的 loginToken 字段
            localStorage.removeItem("loginToken");

            setToken(res.data.token)
            commit('SET_STATE', { token: res.data.token })
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          commit('SET_STATE', { userInfo: res.data })
          commit('SET_STATE', { menus: res.data.menu })
          commit('SET_STATE', { roles: res.data.roles })
          commit('SET_PERMISSIONS', res.data.permissions || [])
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetRoles({ commit }) {
      return new Promise((resolve, reject) => {
        getRoleList().then(res => {
          commit('SET_STATE', { roles: res.data })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_STATE', { token: '' })
          commit('SET_STATE', { roles: [] })
          commit('SET_STATE', { userTypes: [] })
          commit('SET_STATE', { banks: [] })
          commit('SET_STATE', { userInfo: null })
          commit('SET_PERMISSIONS', [])
          // 移除 localStorage 的 loginToken 字段
          localStorage.removeItem("loginToken");

          removeToken()
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_STATE', { token: '' })
        commit('SET_STATE', { roles: [] })
        commit('SET_STATE', { userTypes: [] })
        commit('SET_STATE', { banks: [] })
        commit('SET_STATE', { userInfo: null })
        commit('SET_PERMISSIONS', [])
        // 移除 localStorage 的 loginToken 字段
        localStorage.removeItem("loginToken");

        removeToken()
        resolve()
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/login.js